import React from 'react';
import PropTypes from 'prop-types';
// Model
import mDeviceSlave from 'models/deviceSlave';
import { TYPES as deviceModelTypes } from 'models/deviceModel';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { yesNoAsInvertedList, toBooleanOrNull, toIntegerOrNull } from 'utils/Tools';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import CompanySelectFieldFilter from 'companies/assets/main/CompanySelectFieldFilter';
import DeviceAutoCompleteFilter from 'devices/assets/main/DeviceAutoCompleteFilter';
import DeviceBatchSelectFieldFilter from 'production/assets/deviceBatch/DeviceBatchSelectFieldFilter';
import DeviceModelSelectFieldFilter from 'deviceModels/assets/main/DeviceModelSelectFieldFilter';
import DistributionAutoCompleteFilter from 'distributions/assets/main/DistributionAutoCompleteFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';

const DevicesFilters = ({
  disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    available, companyId, device, deviceModelId, deviceSlaveBatchId, distribution, serial,
  } = filters;

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('serial') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.serial"
              value={serial.value}
              onChange={(value) => onFilterFieldChange('serial', value)}
            />
          </div>
        )}
        {isFieldDisplayable('deviceModelId') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DeviceModelSelectFieldFilter
              deviceModelId={toIntegerOrNull(deviceModelId.value)}
              allowedTypes={[deviceModelTypes.opacSlave]}
              onChange={(value) => onFilterFieldChange('deviceModelId', value)}
            />
          </div>
        )}
        {isFieldDisplayable('available') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.deviceAttached"
              value={toBooleanOrNull(available.value)}
              items={yesNoAsInvertedList}
              onChange={(value) => onFilterFieldChange('available', value)}
            />
          </div>
        )}
        {isFieldDisplayable('device') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DeviceAutoCompleteFilter
              device={device.value}
              onSelect={(value) => onFilterFieldChange('device', value)}
            />
          </div>
        )}
        {isFieldDisplayable('distribution') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DistributionAutoCompleteFilter
              distribution={distribution.value}
              onSelect={(value) => onFilterFieldChange('distribution', value)}
            />
          </div>
        )}
        {isFieldDisplayable('deviceSlaveBatchId') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DeviceBatchSelectFieldFilter
              deviceBatchId={toIntegerOrNull(deviceSlaveBatchId.value)}
              onChange={(value) => onFilterFieldChange('deviceSlaveBatchId', value)}
            />
          </div>
        )}
        {isFieldDisplayable('companyId') && (
          <div className="col-12 col-md-4 col-xl-3">
            <CompanySelectFieldFilter
              companyId={toIntegerOrNull(companyId.value)}
              onChange={(value) => onFilterFieldChange('companyId', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

DevicesFilters.propTypes = {
  // From `wrapListFilters` HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    available: listFilterShape,
    companyId: listFilterShape,
    device: listFilterShape,
    deviceModelId: listFilterShape,
    deviceSlaveBatchId: listFilterShape,
    distribution: listFilterShape,
    serial: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mDeviceSlave.listFeatures.searchFields)(DevicesFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/deviceSlaves/assets/main/DeviceSlaveFilters.js